import type {
  CreateTrialApplicationInput,
  TrialApplication,
  TrialApplicationListResult,
  TrialApplicationReceipt,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export type CreateTrialApplicationData = CreateTrialApplicationInput;

export const createTrialApplication = async (
  data: CreateTrialApplicationData,
): Promise<TrialApplicationReceipt> => {
  const response = await httpClient.post<TrialApplicationReceipt>("/trial-applications", data);
  return response.data;
};

export const findAllTrialApplications = async ({
  page,
  limit,
}: {
  page: number;
  limit: number;
}): Promise<TrialApplicationListResult> => {
  const response = await httpClient.get<TrialApplicationListResult>("/trial-applications", {
    params: { page, limit },
  });
  return response.data;
};

export const findOneTrialApplication = async (id: string): Promise<TrialApplication> => {
  const response = await httpClient.get(`/trial-applications/${id}`);
  return response.data;
};
